import { Injectable } from '@angular/core';
import { Router, CanDeactivate, CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthorizationService, OrderService } from '../services';
import { ToastrService } from 'ngx-toastr';
import { OrderComponent } from '../../../app/components/order/order.component';


export interface DeactivationGuard {
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root'
})
export class OrderGuard implements CanDeactivate<OrderComponent>, CanActivate, CanLoad {

    constructor(
        private router: Router,
        private authService: AuthorizationService,
        private orderService: OrderService) {
    }

    canDeactivate(component: OrderComponent): Observable<boolean> | Promise<boolean> | boolean {
        if (component.getForm('step1').touched && component.getForm('step1').dirty) {
            return confirm(`Are you sure you want to navigate away and discard your changes?`);
        }
        return true;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.checkAccess();
    }

    canLoad(state: Route): boolean {
        return this.checkAccess();
    }

    private checkAccess(): boolean {
        let hasAccess = true;
        if (!this.authService.hasPermission(this.orderService.PERMISSION_CAN_READ_ORDER)) {
            hasAccess = false;
        }
        return hasAccess;
    }
}
